import { defineMessages } from "react-intl";

const baseId = "t.pages.TaskRequestDetail.";

export default defineMessages({
  back: {
    id: baseId + "back",
    defaultMessage: "Back",
  },

  requestDetail: {
    id: baseId + "requestDetail",
    defaultMessage: "Request detail",
  },
  PanelDetailRequestLabelParentId: {
    id: baseId + "panelDetailRequestParentId",
    defaultMessage: "ID Parent",
  },
  PanelDetailRequestLabelId: {
    id: baseId + "panelDetailRequestId",
    defaultMessage: "ID",
  },
  PanelDetailRequestBeneficiaryId: {
    id: baseId + "panelDetailRequestBeneficiaryId",
    defaultMessage: "Beneficiary id",
  },
  PanelDetailRequestBeneficiary: {
    id: baseId + "panelDetailRequestBeneficiary",
    defaultMessage: "Beneficiary",
  },
  PanelDetailRequestBeneficiaryEmail: {
    id: baseId + "panelDetailRequestBeneficiaryEmail",
    defaultMessage: "Beneficiary email",
  },
  PanelDetailRequestApplication: {
    id: baseId + "panelDetailRequestApplication",
    defaultMessage: "Application",
  },

  operationDetail: {
    id: baseId + "operationDetail",
    defaultMessage: "Operation detail",
  },
  applicantDetail: {
    id: baseId + "applicantDetail",
    defaultMessage: "Applicant detail",
  },
  beneficiaryDetail: {
    id: baseId + "beneficiaryDetail",
    defaultMessage: "Beneficiary detail",
  },
  comment: {
    id: baseId + "comment",
    defaultMessage: "Comment",
  },
  addComment: {
    id: baseId + "addComment",
    defaultMessage: "ADD COMMENT",
  },
  removeComment: {
    id: baseId + "removeComment",
    defaultMessage: "REMOVE COMMENT",
  },
  commentPlaceholder: {
    id: baseId + "commentPlaceholder",
    defaultMessage: "Enter comment...",
  },
  execute: {
    id: baseId + "execute",
    defaultMessage: "Execute",
  },
  unexecute: {
    id: baseId + "unexecute",
    defaultMessage: "Unexecute",
  },
  takeCharge: {
    id: baseId + "takeCharge",
    defaultMessage: "Take charge",
  },
  unTakeCharge: {
    id: baseId + "unTakeCharge",
    defaultMessage: "Cancel Take charge",
  },
  notPossibleTakeCharge: {
    id: baseId + "notPossibleTakeCharge",
    defaultMessage: "It's not possible to Take Charge",
  },
  PanelDetailValueTypeADD_ENTITLEMENT_TO_USER: {
    id: baseId + "PanelDetailValueType.addEntitlementToUser",
    defaultMessage: "ADD ENTITLEMENT",
  },
  PanelDetailValueTypeREMOVE_ENTITLEMENT_FROM_USER: {
    id: baseId + "PanelDetailValueType.removeEntitlementToUser",
    defaultMessage: "REMOVE ENTITLEMENT",
  },
  PanelDetailValueTypeADD_BUSINESS_ROLE_TO_USER: {
    id: baseId + "PanelDetailValueType.addBusinessRoleToUser",
    defaultMessage: "ADD BUSINESS ROLE TO USER",
  },
  PanelDetailValueTypeREMOVE_BUSINESS_ROLE_TO_USER: {
    id: baseId + "PanelDetailValueType.removeBusinessRoleToUser",
    defaultMessage: "REMOVE BUSINESS ROLE TO USER",
  },
  PanelDetailValueTypeADD_EMERGENCY_USER_RACF: {
    id: baseId + "PanelDetailValueType.addEmergencyUserRACF",
    defaultMessage: "ADD RACF ENTITLEMENT",
  },
  PanelDetailValueTypeADD_ENTITLEMENT_TO_CATALOG: {
    id: baseId + "PanelDetailValueType.addEntitlementToCatalog",
    defaultMessage: "ADD ENTITLEMENT TO CATALOG",
  },
  PanelDetailValueTypeREMOVE_ENTITLEMENT_FROM_CATALOG: {
    id: baseId + "PanelDetailValueType.removeEntitlementToCatalog",
    defaultMessage: "REMOVE ENTITLEMENT",
  },
  PanelDetailValueTypeRESET_PASSWORD: {
    id: baseId + "PanelDetailValueType.resetPassword",
    defaultMessage: "RESET PASSWORD",
  },
  PanelDetailValueTypeCHANGE_PASSOWRD: {
    id: baseId + "PanelDetailValueType.changePassword",
    defaultMessage: "CHANGE PASSWORD",
  },

  PanelDetailValueStatusAPPROVAL: {
    id: baseId + "PanelDetailValueState.approval",
    defaultMessage: "APPROVAL",
  },
  PanelDetailValueStatusCOMPLETED: {
    id: baseId + "PanelDetailValueState.completed",
    defaultMessage: "COMPLETED",
  },
  PanelDetailValueStatusEXECUTION: {
    id: baseId + "PanelDetailValueState.execution",
    defaultMessage: "EXECUTION",
  },
  PanelDetailValueStatus_EXECUTION: {
    id: baseId + "PanelDetailValueState.execution",
    defaultMessage: "EXECUTION",
  },
  PanelDetailValueStatusERROR: {
    id: baseId + "PanelDetailValueState.error",
    defaultMessage: "ERROR",
  },
  PanelDetailValueStatusREFUSED: {
    id: baseId + "PanelDetailValueState.refused",
    defaultMessage: "REFUSED",
  },
  PanelDetailValueStatusND: {
    id: baseId + "PanelDetailValueState.nd",
    defaultMessage: "ND",
  },
  takeChargeFrom: {
    id: baseId + "takeChargeFrom",
    defaultMessage: "Take charge from: {val}",
  },
  requestLabel: {
    id: baseId + "requestLabel",
    defaultMessage: "Request of",
  },
  forLabel: {
    id: baseId + "forLabel",
    defaultMessage: "for",
  },
  onLabel: {
    id: baseId + "onLabel",
    defaultMessage: "on",
  },

  PERMISSION_ADD: {
    id: baseId + "PERMISSION_ADD",
    defaultMessage: "ADD PERMISSION",
  },
  PERMISSION_REMOVE: {
    id: baseId + "PERMISSION_REMOVE",
    defaultMessage: "REMOVE PERMISSION",
  },
  ACCOUNT_DISABLE: {
    id: baseId + "ACCOUNT_DISABLE",
    defaultMessage: "DISABLE ACCOUTN",
  },
  ACCOUNT_ENABLE: {
    id: baseId + "ACCOUNT_ENABLE",
    defaultMessage: "ENABLE ACCOUNT",
  },
  ACCOUNT_CREATE: {
    id: baseId + "ACCOUNT_CREATE",
    defaultMessage: "CREATE ACCOUNT",
  },
  ACCOUNT_REMOVE: {
    id: baseId + "ACCOUNT_REMOVE",
    defaultMessage: "REMOVE ACCOUNT",
  },
  ACCOUNT_MODIFY: {
    id: baseId + "ACCOUNT_MODIFY",
    defaultMessage: "MODIFY ACCOUNT",
  },
  ACCOUNT_PWDCHANGE: {
    id: baseId + "ACCOUNT_PWDCHANGE",
    defaultMessage: "ACCOUNT PASSWORD CHANGE",
  },

  entitlementLabel: {
    id: baseId + "entitlementLabel",
    defaultMessage: "Entitlement:",
  },
  userIdLabel: {
    id: baseId + "userIdLabel",
    defaultMessage: "User id:",
  },
  entitlementDescriptionLabel: {
    id: baseId + "entitlementDescriptionLabel",
    defaultMessage: "Entitlement:",
  },
  applicationLabel: {
    id: baseId + "applicationLabel",
    defaultMessage: "Application:",
  },

  emptyModalTitle: {
    id: baseId + "emptyModalTitle",
    defaultMessage: "ATTENTION",
  },
  emptyModalMessage: {
    id: baseId + "emptyModalMessage",
    defaultMessage:
      "No task is selected, please select at least one task to execute or unexecute",
  },

  modalTakeChargeTitle: {
    id: baseId + "modalTakeChargeTitle",
    defaultMessage: "TAKE CHARGE",
  },
  ctaTakeChargeAction: {
    id: baseId + "ctaTakeChargeAction",
    defaultMessage: "TAKE/UNTAKE CHARGE",
  },
});
